<template>
  <v-container class="pa-6">
    <div style="margin-bottom: 24px">
      <div class="component-title">Thông tin đơn phúc khảo</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="items"
        ><template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>

    <GradeReviewInfo :profile="profile" @refresh="refresh" />
    <v-card style="margin-bottom: 24px" outlined>
      <div class="d-flex justify-space-between align-items-center px-6 pt-6">
        <h5 class="text-uppercase align-self-center">Trạng thái đơn</h5>
      </div>
      <v-stepper v-model="currentStep" non-linear alt-labels class="stepper elevation-0">
        <v-stepper-header>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(1)"
            step="1"
            @click="handleStepClick(1)"
          >
            Chưa duyệt
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(2)"
            step="2"
            @click="handleStepClick(2)"
          >
            Đã duyệt
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(3)"
            step="3"
            @click="handleStepClick(3)"
          >
            Đã có kết quả
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <div class="px-6 pb-6">
        <span style="color: red">*</span>
        <span style="color: grey; font-size: smaller">
          Xin vui lòng bấm vào một bước trên để thay đổi trạng thái đơn</span
        >
      </div>
    </v-card>
    <GradeReviewGrade :profile="profile" @refresh="refresh" />
    <div class="d-flex justify-center align-center mt-6">
      <v-btn color="red" outlined @click="deleteDialog = true">Xóa đơn phúc khảo này</v-btn>
    </div>

    <v-dialog v-model="deleteDialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline">Xác nhận xóa đơn phúc khảo</v-card-title>
        <v-card-text> Bọn có chắc là bạn muốn xóa đơn phúc khảo này không? </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-4" text @click="deleteDialog = false" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="deleteForm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import GradeReviewInfo from '../../modules/exam/GradeReviewInfo.vue'
import GradeReviewGrade from '../../modules/exam/GradeReviewGrade.vue'
export default {
  components: {
    GradeReviewInfo,
    GradeReviewGrade
  },
  data() {
    return {
      profile: {},
      sortedLogs: [],
      showAppointment: false,
      showProduct: false,
      showMenu: false,
      deleteDialog: false,
      productsList: [],
      users: [],
      items: [
        {
          text: 'Đơn phúc khảo',
          disabled: false,
          href: '/exam-mark-review'
        },
        {
          text: 'Thông tin đơn',
          disabled: false
        }
      ]
    }
  },

  mounted() {
    this.getProfileData()
  },
  computed: {
    ...mapGetters('auth', ['user']),

    currentStep() {
      switch (this.profile.status) {
        case 'notSeen':
          return 1
        case 'approved':
          return 2
        case 'hasResult':
          return 3
        default:
          return 0
      }
    }
  },
  methods: {
    ...mapActions('gradeReview', ['fetchGradeReview', 'updateGradeReview']),
    async getProfileData() {
      this.$loading.active = true
      const id = this.$route.params.id
      try {
        const response = await this.fetchGradeReview(id)
        this.profile = response
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    isStepComplete(stepNumber) {
      return this.currentStep > stepNumber
    },
    handleStepClick(step) {
      switch (step) {
        case 1:
          this.updateStatus('notSeen')
          break
        case 2:
          this.updateStatus('approved')
          break
        case 3:
          this.updateStatus('hasResult')
          break
      }
    },
    async updateStatus(newStatus) {
      this.$loading.active = true
      try {
        const updatedForm = await this.updateGradeReview({ id: this.profile.id, status: newStatus })
        if (updatedForm) {
          this.profile.status = updatedForm.status
        }

        this.$alert.success('Đã cập nhập trạng thái thành công')
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async deleteForm() {
      await this.updateGradeReview({ id: this.profile.id, isArchived: 'true' })
      this.$alert.success('Xóa đơn thành công')
      this.deleteDialog = false
      this.$router.push('/exam-mark-review')
    },
    refresh() {
      this.getProfileData()
    },
    setStatus(newStatus) {
      this.updateStatus(newStatus)
      this.showMenu = false
    }
  }
}
</script>

<style>
.stepper .v-stepper__label {
  text-align: center !important;
}

.clickable-step:hover {
  cursor: pointer;
}

.clickable-step:hover .v-stepper__label {
  color: #0d47a1 !important;
}

.button-background {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}
.return-btn {
  text-transform: lowercase !important;
  opacity: 1 !important;
}
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
.non-clickable-step {
  cursor: not-allowed !important;
}
</style>
